import React from 'react'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { ArrowRightIcon } from '../../../components/ui/ArrowRightIcon'
import { colors } from '../../../theme'
import { body3, label1 } from '../../../theme/typography'
import { VoiceAssessmentBetaBadge } from '../../voice-assessment/components/VoiceAssessmentBetaBadge'
import { formatMeasurementReminderDurationLabel } from '../utils/measurement-reminder-duration'

type MeasurementReminderBannerProps = Readonly<{
  estimatedDurationMinutes?: number | null
  onPress?: () => void
}>

export function MeasurementReminderBanner({
  estimatedDurationMinutes,
  onPress,
}: MeasurementReminderBannerProps) {
  const { t } = useTranslation(['dashboard'])
  const estimatedDurationLabel = formatMeasurementReminderDurationLabel({
    estimatedDurationMinutes,
    minutesShortLabel: t('dashboard:minutes_short'),
  })

  return (
    <Pressable disabled={!onPress} onPress={onPress} style={styles.banner}>
      <View className="flex-row items-center justify-between">
        <View style={styles.textBlock}>
          <View className="flex-row items-center gap-2">
            <Text numberOfLines={1} style={styles.title}>
              {t('dashboard:measurement_reminder_title')}
            </Text>
            <VoiceAssessmentBetaBadge testID="measurement-reminder-beta-badge" />
          </View>
          {estimatedDurationLabel != null ? (
            <Text style={styles.subtitle}>
              {t('dashboard:measurement_reminder_duration', {
                duration: estimatedDurationLabel,
              })}
            </Text>
          ) : null}
        </View>

        <View className="items-center justify-center" style={{ width: 24 }}>
          <ArrowRightIcon color={colors.textHeader} />
        </View>
      </View>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  banner: {
    minHeight: 80,
    marginBottom: 8,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: colors.coreSecondary,
    backgroundColor: colors.secondary700,
    paddingTop: 20,
    paddingRight: 16,
    paddingBottom: 20,
    paddingLeft: 16,
    boxShadow: '0px 2px 5px 0px #0000000D',
  },
  textBlock: {
    flex: 1,
    minWidth: 0,
    paddingRight: 16,
  },
  title: {
    ...label1,
    flexShrink: 1,
    color: colors.textHeader,
  },
  subtitle: {
    ...body3,
    marginTop: 6,
    color: colors.textHeader,
  },
})
